import { Field, formValueSelector, reduxForm } from 'redux-form';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import { SubmitBatchPaperClaimsForNonEDIPayers } from '../manageClaims/actions/ManageClaimActions';
import { renderAutoCompleteSingleSelect, renderCheckBox } from '../../../../components/reduxFields';
import { CommonButton } from '../../../../components/buttons';
import SmallLoader from '../../../../img/small-loader.gif';

const validate = (values) => {
  const errors = {};
  if (!values.claimFormPrintFormat) {
    errors.claimFormPrintFormat = 'Please select print format.';
  }
  return errors;
};

class BatchGenerateForm1500Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      ClaimFormPrintFormat: [{ id: 1, value: 'Normal' }, { id: 2, value: 'Pre-Printed' }],
    };
    this.onSubmitHandler = this.onSubmitHandler.bind(this);
  }

  componentWillReceiveProps(nextProps) {

    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  }

  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  onSubmitHandler(formData) {
    let postData = {
      claimIds: this.props.selectedEDIAndNonEDIClaimIds,
      payerPreference: 'primary',
      markSubmitted: formData.markSubmitted || false,
      printFormat: formData.claimFormPrintFormat,
    };
    // console.log(JSON.stringify(postData));
    this.props.SubmitBatchPaperClaimsForNonEDIPayers(postData.claimIds, postData.payerPreference, postData.markSubmitted, postData.printFormat, 'READYTOBILL');
    this.handleClose();
  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    const actions = [
      <CommonButton label="Cancel" className="mr-15 grey_btn" onTouchTap={() => this.handleClose()} />,
      <CommonButton type="submit" primary={true} label="Generate Claim(s)" onTouchTap={handleSubmit(this.onSubmitHandler)} />,
    ];
    return (
      <Dialog className="custom_modal"
        title={'Generate Batch Form 1500'}
        modal={false}
        open={this.state.open}
        actions={actions}
        autoScrollBodyContent={true}>
        <div className="row">
          <div className="col-sm-12">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
              <div className="row">
                <div className="col-sm-6 mt-40">
                  <Field
                    name="markSubmitted"
                    label="Mark Submitted"
                    // defaultChecked={this.state.IsClaimForm1500 ? false : true}
                    component={renderCheckBox} />
                </div>
                <div className='col-sm-6 require  mt-35'>
                  <Field
                    name="claimFormPrintFormat"
                    label="Print Formats"
                    options={this.state.ClaimFormPrintFormat}
                    handleNewRequest={this.handleNewRequest}
                    component={renderAutoCompleteSingleSelect} />
                </div>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    );
  };
}

BatchGenerateForm1500Modal = reduxForm({
  form: 'BatchGenerateForm1500Modal',
  validate,
  enableReinitialize: true,
})(BatchGenerateForm1500Modal);

const selector = formValueSelector('BatchGenerateForm1500Modal');
function mapStateToProps(state) {
  return {
    loading: state.billing.loading,
  };
}

export default connect(mapStateToProps, { SubmitBatchPaperClaimsForNonEDIPayers })(BatchGenerateForm1500Modal);



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/BatchGenerateForm1500_Modal.js